import React from 'react';

import { type AnalyticsEvent, pushAnalyticsEvent } from 'utils/analytics';

export const usePageViewEvent = (eventId: AnalyticsEvent) => {
    React.useEffect(() => {
        pushAnalyticsEvent(eventId, {
            pageUrl: window.location.href,
            route: window.location.pathname,
            referrer: document.referrer,
        });
    }, [eventId]);
};
